import { Route, Redirect, useLocation } from 'react-router-dom'

import {
  ROUTE_LOGIN_PRIVATE,
  ROUTE_LOGOUT
} from 'components/common/helpers/Paths'
import { isAuthenticated } from '.'
import { isAndroid, isiOS } from 'components/common/helpers/Mobile'

/**
 * Private route component. Redirects to login page if user is not authenticated
 * @param {*} param0
 * @returns
 */
export default function PrivateRoute({ component: Component, ...rest }) {
  const { search, pathname } = useLocation()
  const searchParams = new URLSearchParams(search)

  // Override the redirect path if it's set in the query params
  if (pathname && pathname !== '/') searchParams.set('returnPath', pathname)

  // If the user is in the app and has the right version, we want to redirect to the private login page
  const logoutUrl =
    isiOS('1.2.0') || isAndroid('1.2.0') ? ROUTE_LOGIN_PRIVATE : ROUTE_LOGOUT

  // Pass through query params to the route
  const loginUrl = `${logoutUrl}${
    searchParams.toString() ? '?' : ''
  }${searchParams.toString()}`

  return (
    // Show the component only when the user is logged in
    // Otherwise, redirect the user to /login page
    <Route
      {...rest}
      render={props =>
        isAuthenticated() ? (
          <Component {...props} {...rest} />
        ) : (
          <Redirect to={loginUrl} />
        )
      }
    />
  )
}
